'use client';

import { ReactElement, useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

interface GlobalErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

// Catches crashes in the root layout — the last safety net before a blank page.
// Must be a Client Component and must render its own <html>/<body>.
export default function GlobalError({ error, reset }: GlobalErrorProps): ReactElement {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <html lang="en">
            <body>
                <p>Something went wrong.</p>
                <button onClick={reset}>Try again</button>
            </body>
        </html>
    );
}
